<template>
    <div class="other-data">

        <div class="ul-sns-btns-wrap">
            <input type="hidden" value="facebook:1,twitter:1,pocket:1,googleplus:1,hatena:1,linkedin:1"
                class="exist_btn">
            <ul class="sns-btns large-sns-btns buttonDisplay">
                <li id="facebook-count" class="fb"><a href="#" @click.prevent="openShare(facebookUrl)"><img
                            src="@/assets/img/static_pages/facebook.svg" alt="Facebook"><span></span></a>
                </li>
                <li id="twitter-count" class="tw"><a href="#" @click.prevent="openShare(twitterUrl)"><img
                            src="@/assets/img/static_pages/x.svg" alt="X (formerly Twitter)"><span></span></a>
                </li>
                <li id="linkedin-count" class="in"><a href="#" @click.prevent="openShare(linkedinUrl)"><img
                            src="@/assets/img/static_pages/linkedin.svg" alt="Linkedin"><span></span></a>
                </li>
            </ul>

        </div>
    </div>
</template>
<script setup>
const pageUrl = encodeURIComponent(window.location.href)
const title = encodeURIComponent(document.title)
const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`
const twitterUrl = `https://twitter.com/intent/tweet?url=${pageUrl}&text=${title}`
const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`
const openShare = (url) => {
    window.open(url, '_blank', 'width=600,height=500')
}

</script>